import ReactApexChart from 'react-apexcharts'

import { PlanData } from './types'

type PlansPopularityChartProps = {
  plansData: PlanData[]
}

export const PlansPopularityChart: React.FC<PlansPopularityChartProps> = ({
  plansData,
}) => {
  const filteredPlans = plansData.filter((plan) => plan.totalSubscriptions > 0)

  return (
    <div className='bg-white rounded-xl shadow-md p-6 overflow-hidden'>
      <h2 className='text-lg font-semibold text-gray-700 mb-6'>
        Popularidade dos Planos
      </h2>
      <div className='flex flex-col'>
        <div className='flex flex-col md:flex-row items-center mb-6'>
          <div className='w-full md:w-1/2 mb-4 md:mb-0'>
            <ReactApexChart
              type='donut'
              height={280}
              width='100%'
              options={{
                chart: {
                  type: 'donut',
                },
                labels: filteredPlans.map((plan) => plan.planName),
                colors: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'],
                legend: {
                  show: false,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size: '55%',
                      labels: {
                        show: true,
                        name: {
                          show: true,
                        },
                        value: {
                          show: true,
                          formatter: function (val) {
                            return val + ' assinaturas'
                          },
                        },
                        total: {
                          show: true,
                          label: 'Total',
                          formatter: function (w) {
                            return (
                              w.globals.seriesTotals.reduce(
                                (a: number, b: number) => a + b,
                                0,
                              ) + ' assinaturas'
                            )
                          },
                        },
                      },
                    },
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      chart: {
                        height: 250,
                      },
                      legend: {
                        show: false,
                      },
                    },
                  },
                ],
              }}
              series={filteredPlans.map((plan) => plan.totalSubscriptions)}
            />
          </div>
          <div className='w-full md:w-1/2 flex justify-center'>
            <div className='flex flex-col justify-center space-y-2'>
              {filteredPlans.map((plan, index) => (
                <div key={plan.planId} className='flex items-center'>
                  <div 
                    className='w-4 h-4 rounded mr-3 flex-shrink-0'
                    style={{ backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'][index] }}
                  ></div>
                  <span className='text-sm text-gray-700'>
                    {plan.planName}: {plan.totalSubscriptions} assinaturas
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className='mt-6'>
          <table className='min-w-full'>
            <thead>
              <tr>
                <th className='text-left text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Plano
                </th>
                <th className='text-center text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Ativos
                </th>
                <th className='text-center text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Cancelados
                </th>
                <th className='text-center text-xs font-medium text-gray-500 uppercase tracking-wider pb-2'>
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredPlans.map((plan) => (
                <tr key={plan.planId} className='border-t border-gray-200'>
                  <td className='py-2 text-sm text-gray-700'>
                    {plan.planName}
                  </td>
                  <td className='py-2 text-sm text-center text-gray-700'>
                    {plan.activeNowCustomers}
                  </td>
                  <td className='py-2 text-sm text-center text-gray-700'>
                    {plan.canceledSubscriptions}
                  </td>
                  <td className='py-2 text-sm text-center text-gray-700'>
                    {plan.totalSubscriptions}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
